<template>
  <GlobalLoading />
  
  <LoadingComponent />

  <InstallPromptComponent v-if="!isAndroidApp" />

  <OfflineModeComponent v-if="systemStore.maintenanceMode" />
  
  <div class="app-background w-100">
    <!-- Private Layout for authenticated users -->

    <div
      v-if="authStore.isLoggedIn && $route.meta.requiresAuth"
      id="private"
      class="app-container container-large d-flex flex-column flex-xl-row"
    >         
      <div class="d-flex flex-column order-2 order-xl-1 flex-xl-row align-items-start navbar-custome custom-h-100">
        <NavBarComponent id="NavBarComponent" />
      </div>
      <div class="flex-grow-1 order-1 order-xl-2 h-100 w-100">
        <RouterView name="private" />
      </div>
    </div>

    <!-- Public Layout for both authenticated and non-authenticated users -->
    <div
      v-else
      id="public"
      class="app-container container-small d-flex flex-column w-100"
    >     
      <div class="position-relative w-100 p-5">      
        <!-- <LanguageSwitcherComponent class="position-absolute end-0" /> -->
        <LecLogo
          :shrink-img="true"
        />
      </div>
      <div class="order-1 order-xl-2 flex-grow-1 d-flex w-100">
        <!-- router-view-padding2 -->
        <RouterView
          class="router-view-padding px-3 pb-4 w-100 pt-0 pt-md-3 w-100"
          name="public"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted} from 'vue';
import NavBarComponent from '@/components/shared/NavBarComponent.vue';
import LecLogo from '@/components/header/LecLogo.vue';
import LoadingComponent from '@/components/shared/LoadingComponent.vue';
import { useLoadingStore } from '@/stores/useLoadingStore';
import { useAuthStore } from '@/stores/authStore';
import InstallPromptComponent from '@/components/shared/InstallPromptComponent.vue';
import GlobalLoading from '@/components/shared/GlobalLoadingComponent.vue';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { useSystemStore } from '@/stores/systemStore';
import OfflineModeComponent from '@/components/shared/OfflineComponent.vue';
import { useMessaging } from '@/composables/useMessaging';


export default defineComponent({
  components: {
    NavBarComponent,
    LecLogo,
    LoadingComponent,
    InstallPromptComponent,
    GlobalLoading,
    OfflineModeComponent
  },
  setup() {
    const loadingStore = useLoadingStore();
    const authStore = useAuthStore();
    const { registerHandlers } = useMessaging();
    const isAndroidApp = Capacitor.getPlatform() === 'android';
    const isNativeApp = Capacitor.isNativePlatform()
    const isIosApp = Capacitor.getPlatform() === 'ios'
    const systemStore = useSystemStore();
    

    onMounted(async () => {      
      
      if (isNativeApp) {
        if (isIosApp) {
          //await StatusBar.setStyle({ style: Style.Light });
          //await StatusBar.setBackgroundColor({ color: '#000000' });
        } else if (isAndroidApp) {
          //await StatusBar.setBackgroundColor({ color: '#000000' });
         // await StatusBar.setStyle({ style: Style.Dark });
        }
      }

      await authStore.fetchUserIfNeeded();
      const loadingItem = loadingStore.addToLoadingStack('simulated-loading');
      setTimeout(() => {    
        loadingStore.removeFromLoadingStack(loadingItem);
      }, 0);

      if (authStore.user) {
        await registerHandlers(authStore.user);
      }
    });


    return {
      authStore, 
      isNativeApp,
      isAndroidApp,
      systemStore,
      isIosApp,
    };
  },
});
</script>

<style lang="scss">
html, body {
  font-family: var(--base-font);
}

.app-background {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: 0;

  // Uncomment for dev background
  // background: lightgray;

 

  &.keyboard-is-open {
    overflow: auto;
  }

  @media (min-width: 1399.98px) {
    padding: 1rem;
  }
}


.app {
  background-image: url('@/assets/img/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  
}


.app-container {
  // background-color: yellow;
  background-color: #fff;
  box-shadow: 0px 0px 40px 0px #00000026;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
 

  @media (max-width: 1399.98px) {
    height: 100dvh;
    width: 100%;
    border-radius: 0;
    box-shadow: none;
  }

  @media (min-width: 1399.98px) {
    height: 100%;
  }
}


@media (min-width: 1399.98px) {
  .pt-md-3 {
    padding-top: 0 !important;
  }
}


.container-small {
  @media (min-width: 1399.98px) {
    max-width: 768px;
    min-height: 768px;
    height: auto;
  }
}

.container-large {
  @media (min-width: 1399.98px) {
    width: 90vw;
    height: 95vh;
  }
}


.navbar-custome {
  @media (max-width: 1199.98px) {
    width: 100%;
  }
}


.custom-h-100 {
  height: auto;

  @media (min-width: 1199.98px) {
    height: 100%;
  }
}

.maintenance-mode {
  backdrop-filter: blur(4px);
  z-index: 99999;
}





</style>
